"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
__export(require("./Label"));

//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ../components/Label/index.js
// module id = 91
// module chunks = 0